// utils.js yoki helpers.js ichida
import { BASE_URL } from '@/api/api';

export const normalizeUrl = (url) => {
  if (!url) return null;

  // Barcha "/apis" so'zlarini tozalaymiz (birinchisini emas, hammasini)
  let cleanedUrl = url.replaceAll("/apis", "");

  // Agar to‘liq URL bo‘lsa (http yoki https), BASE_URL qo‘shmaymiz
  if (cleanedUrl.startsWith("http")) {
    return cleanedUrl;
  }

  // Aks holda BASE_URL bilan birlashtiramiz
  return BASE_URL + cleanedUrl;
};


export const getFileName = (url) => {
  if (!url) return "";
  return url.split("/").pop();
};